<template>
    <div></div>
</template>

<script>
import Swiper from '../assets/js/swiper.min.js'
import * as swiperAni from '../assets/js/animate.js'
import WOW from '../assets/js/wow.js'
import '../assets/js/swiper.min.css'
import '../assets/js/animate.min.css'
import $ from 'jquery'

export default {
    data: function () {
		return {
			
		};
    },
	mounted() {
        $(function(){
            //
            $('.indexmaxlistwo .list .icon .li').click(function(){
                var index = $(this).index();
                $('.indexmaxlistwo .swiper-pagination span').eq(index).trigger('click');
            });
            $('.serveboxmaxone .li').eq(0).click(function(){
                var y = $('.aboutopcomm').height() + $('.serveboxmaxone').height() + 63;
                window.scrollTo(0,y);
            });
            $('.serveboxmaxone .li').eq(1).click(function(){
                var y = $('.aboutopcomm').innerHeight() + $('.serveboxmaxone').innerHeight() + $('.serveboxmaxlist .wli1').innerHeight() + 63;
                window.scrollTo(0,y);
            });
            $('.serveboxmaxone .li').eq(2).click(function(){
                var y = $('.aboutopcomm').innerHeight() + $('.serveboxmaxone').innerHeight() + $('.serveboxmaxlist .wli1').innerHeight() + $('.serveboxmaxlist .wli2').innerHeight() + 63;
                window.scrollTo(0,y);
            });
            $('.serveboxmaxone .li').eq(3).click(function(){
                var y = $('.aboutopcomm').innerHeight() + $('.serveboxmaxone').innerHeight() + $('.serveboxmaxlist .wli1').innerHeight() + $('.serveboxmaxlist .wli2').innerHeight() + $('.serveboxmaxlist .wli3').innerHeight() + 120;
                window.scrollTo(0,y);
            });
            $('.serveboxmaxone .li').eq(4).click(function(){
                var y = $('.aboutopcomm').innerHeight() + $('.serveboxmaxone').innerHeight() + $('.serveboxmaxlist .wli1').innerHeight() + $('.serveboxmaxlist .wli2').innerHeight() + $('.serveboxmaxlist .wli3').innerHeight() + $('.serveboxmaxlist .wli4').innerHeight() + 120;
                window.scrollTo(0,y);
            });
            $('.serveboxmaxone .li').eq(5).click(function(){
                var y = $('.aboutopcomm').innerHeight() + $('.serveboxmaxone').innerHeight() + $('.serveboxmaxlist .wli1').innerHeight() + $('.serveboxmaxlist .wli2').innerHeight() + $('.serveboxmaxlist .wli3').innerHeight() + $('.serveboxmaxlist .wli4').innerHeight() + $('.serveboxmaxlist .wli5').innerHeight() + 120;
                window.scrollTo(0,y);
            });
            //
            $(window).scroll(function(){
                var scrollTop　=　document.documentElement.scrollTop || document.body.scrollTop;
                if(scrollTop > 20 ){
                    $('.headercp').addClass('headercp2');
                }else{
                    $('.headercp').removeClass('headercp2');
                }
            });
            //
            $('.headercp .cont .nav .li').mouseenter(function(){
                if( $('.headercp .cont .nav .on .tit').text() == '服务' ){
                    $('.headercplist').hide();
                } else if( $(this).children('.tit').text() == '服务' ){
                    $('.headercplist').slideDown();
                } else {
                    $('.headercplist').slideUp();
                }
            });
            $('.headercplist .sole').click(function(){
                $('.headercplist').slideUp();
            });
            //
            $('.minkNaver .li:last-child').click(function(){
                var scrollToTop = window.setInterval(function() {
                    var pos = window.pageYOffset;
                    if ( pos > 0 ) {
                        window.scrollTo( 0, pos - 20 ); // how far to scroll on each step
                    } else {
                        window.clearInterval( scrollToTop );
                    }
                }, 16);
            });
            //
            $('body .moreboxmax .a2').click(function(){
                $('.videoBoxWent').addClass('videoBoxWent2');
            });
            $('.videoBoxWent .sole, .videoBoxWent .up').click(function(){
                $('.videoBoxWent').removeClass('videoBoxWent2');
            });
            //
            $('body .moreboxmax .play').click(function(){
                $('.videoBoxWent').addClass('videoBoxWent2');
                var myVideo = document.getElementById("video");
                myVideo.play();
            });
            $('.videoBoxWent .sole, .videoBoxWent .up').click(function(){
                $('.videoBoxWent').removeClass('videoBoxWent2');
                var myVideo = document.getElementById("video");
                myVideo.pause();
            });
        });
		//
		var swiper = new Swiper('.bannerbox .swiper-container', {
			// loop: true,
			// autoplay: true,
            autoplay: { 
                delay: 5000,
                disableOnInteraction: false,
            },
			effect: 'fade',
			pagination: {
				el: '.bannerbox .swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.bannerbox .swiper-button-next',
				prevEl: '.bannerbox .swiper-button-prev',
			},
			on: {
				init: function(){
					swiperAni.swiperAnimateCache(this); //隐藏动画元素 
					swiperAni.swiperAnimate(this); //初始化完成开始动画
				}, 
				slideChangeTransitionStart: function(){ 
					swiperAni.swiperAnimate(this); //每个slide开始切换时也运行当前slide动画
					// this.slides.eq(this.activeIndex).find('.ani').removeClass('ani');  //动画只展现一次，去除ani类名
				} 
			}
		});
        //
        var swiper2 = new Swiper('.indexmaxlistwo .swiper-container', {
			// loop: true,
			// sssautoplay: true,
			effect: 'fade',
			pagination: {
				el: '.indexmaxlistwo .swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.indexmaxlistwo .swiper-button-next',
				prevEl: '.indexmaxlistwo .swiper-button-prev',
			},
			on: {
				slideChangeTransitionStart: function(){ 
					//swiperAni.swiperAnimate(this); //每个slide开始切换时也运行当前slide动画
					// this.slides.eq(this.activeIndex).find('.ani').removeClass('ani');  //动画只展现一次，去除ani类名
                    var uu = $('.indexmaxlistwo .swiper-pagination-bullet-active').index();
                    // console.log(uu)
                    $('.indexmaxlistwo .list .icon .li').eq(uu).addClass('cur').siblings().removeClass('cur');
				} 
			}
		});
		//
		var galleryThumbs = new Swiper('.indexList .cont .swiper-container', {
			loop: true,
			autoplay: true,
			slidesPerView: 4,
			pagination: {
				el: '.indexList .cont .swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.indexList .cont .swiper-button-next',
				prevEl: '.indexList .cont .swiper-button-prev',
			}
		});
		//
		let wow = new WOW.WOW({
			boxClass: 'wow', 
			animateClass: 'animated',
			offset: 0, 
			mobile: true, 
			live: true ,
		}); 
		wow.init();
        //
	},
	methods: {
        
	},
	components: {
		
	}/* ,
	created() {
		// console.log($('#app'));
	} */
}
</script>

<style>
</style>
